<template>
  <!-- 关于我们 -->
  <div class="aboutNav">
    <!-- 头部 -->

    <headerNav activeIndex="aboutUs" @setBanner="setBanner" @getUrl="getUrl"></headerNav>
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div style="padding: 0 72px 148px" class="pc">
      <!-- 轮播图 -->

      <div class="maxWidth mainNav" id="mainNav">
        <!-- 目录 -->
        <div class="mainIndex">
          <ul id="aboutUsIndex" :style="show ? 'opacity:0;z-index:-1' : ''">
            <li class="title Regular">关于我们</li>
            <li class="index">
              <span
                class="selectBtn1"
                :class="navIndex === 1 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('brandProfileNav')"
                >品牌简介</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 2 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('brandCultureNav')"
                >品牌文化</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 3 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('brandAdvantageNav')"
                >品牌优势</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 4 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('CERTIFICATENav')"
                >品牌荣誉</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 5 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('historyNav')"
                >品牌历程</span
              >
            </li>
          </ul>
        </div>
        <!-- 浮动目录 -->
        <div class="mainIndex" style="position: fixed; top: 105px">
          <ul
            id="aboutUsIndex"
            style="position: relative"
            :style="show ? '' : 'opacity:0;z-index:-1'"
          >
            <div
              :style="`position:absolute;top:${top}px;right:55px;width:74px;height:2px;background:#3f6b33;transition: all 0.5s;`"
            ></div>
            <li class="title Regular">关于我们</li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 1 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('brandProfileNav')"
                >品牌简介</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 2 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('brandCultureNav')"
                >品牌文化</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 3 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('brandAdvantageNav')"
                >品牌优势</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 4 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('CERTIFICATENav')"
                >品牌荣誉</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 5 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav('historyNav')"
                >品牌历程</span
              >
            </li>
          </ul>
        </div>
        <!-- 右侧内容 -->
        <div class="mainContent">
          <!-- 品牌简介 -->
          <div
            id="brandProfileNav"
            class="brandProfileNav"
            style="padding: 0 88px"
          >
            <div
              style="
                position: absolute;
                top: 50px;
                left: 0;
                width: 100%;
                z-index: -1;
              "
            >
              <img src="@/assets/bg1.png" style="width: 100%" alt="" />
            </div>
            <div style="margin: 0 auto 0; width: 115px; padding: 61px 0 59px">
              <img src="@/assets/logo.png" style="width: 100%" alt="" />
            </div>
            <div class="display-flex" style="align-items: center">
              <div
                style="width: 220px; position: relative"
                class="animal"
                :style="
                  brandProfileNavShow
                    ? ''
                    : 'transform: translateX(-300px);opacity:0'
                "
              >
                <div
                  style="width: 61px; height: 278px; border: 1px solid #000"
                ></div>
                <div
                  style="
                    position: absolute;
                    top: 56px;
                    left: 60px;
                    height: 98px;
                    width: 4px;
                    background: #eee;
                  "
                ></div>
                <div
                  style="
                    position: absolute;
                    top: 56px;
                    left: 23px;
                    padding: 20px 0;
                  "
                >
                  <div
                    style="color: #010101; font-size: 32px; line-height: 32px"
                  >
                    品牌简介
                  </div>
                  <div
                    style="
                      color: #7d7d7d;
                      font-size: 15px;
                      line-height: 15px;
                      margin-top: 11px;
                    "
                  >
                    BRADN PROFILE
                  </div>
                </div>
              </div>
              <div
                style="width: calc(100% - 220px)"
                class="animal"
                :style="
                  brandProfileNavShow
                    ? ''
                    : 'transform: translateX(300px);opacity:0'
                "
              >
                <div style="font-size: 19px; line-height: 32px; color: #434343">
                  御方汇隶属黄家圣幸实业集团旗下品牌，致力于功效性植物复方原液原料的研发、生产、销售以及产品的转化应用。
                </div>
                <div
                  class="bold"
                  style="
                    font-size: 25px;
                    line-height: 32px;
                    color: #434343;
                    margin-top: 30px;
                  "
                >
                  黄家圣幸实业集团简介
                </div>
                <div
                  style="
                    font-size: 16px;
                    line-height: 32px;
                    color: #434343;
                    margin-top: 15px;
                  "
                >
                  黄家圣幸实业集团有限公司是一家致力于“尖端中医治疗医养服务”、“功效性植物复方原液原料供应”、“功效性植物复方原液原料产品转化”三大优势产业发展的中医药高新技术企业，以前瞻性的战略思维和极具核心竞争力的功效性植物复方研究，转化能力，打造成集产，学、研、医为一体的圣幸健康产业链和圣幸专属健康产业园。
                </div>
              </div>
            </div>
            <div style="margin-top: 46px">
              <img src="@/assets/jieshao1.png" style="width: 100%" alt="" />
            </div>
          </div>
          <!-- 品牌文化 -->
          <div
            class="brandCultureNav"
            ref="brandCultureNav"
            id="brandCultureNav"
          >
            <div
              style="
                position: absolute;
                top: 50px;
                left: 0;
                width: 100%;
                z-index: 0;
              "
            >
              <img src="@/assets/bg2.png" style="width: 100%" alt="" />
            </div>
            <div style="position: relative; z-index: 2">
              <div
                class="Regular"
                style="color: #000000; font-size: 34px; line-height: 32px"
              >
                品牌文化
              </div>
              <div
                style="
                  color: #7d7d7d;
                  font-size: 15px;
                  line-height: 15px;
                  margin-top: 11px;
                "
              >
                BRADN CULTURE
              </div>
            </div>
            <div class="brandCultureNav-content" ref="brandAdvantageNav">
              <div
                class="wrap enlarge"
                v-for="(item, index) of brandCultureList"
                :key="index"
              >
                <img
                  src="@/assets/bg3.png"
                  style="
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                  "
                  alt=""
                />
                <!-- <div class="wrap_left_top"></div>
                <div class="wrap_right_top"></div>
                <div class="wrap_left_bottom"></div>
                <div class="wrap_right_bottom"></div> -->
                <div style="margin: 0 auto; width: 23px; color: #535353">
                  <span class="bold" style="color: #444; font-size: 23px">{{
                    item.title
                  }}</span>
                  <div
                    style="
                      width: 1px;
                      height: 30px;
                      background: #535353;
                      margin: 10px auto 0;
                    "
                  ></div>
                  <span>{{ item.remark }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 品牌优势 -->
          <div class="brandAdvantageNav" id="brandAdvantageNav">
            <div>
              <div
                class="Regular"
                style="color: #000000; font-size: 32px; line-height: 32px"
              >
                品牌优势
              </div>
              <div
                style="
                  color: #7d7d7d;
                  font-size: 15px;
                  line-height: 15px;
                  margin-top: 11px;
                "
              >
                BRADN ADVANTAGE
              </div>
            </div>
            <div class="brandAdvantageNav-content">
              <div
                v-for="(item, index) of brandAdvantagesList"
                :key="index"
                style="width: 252px"
              >
                <div style="width: 100%" class="brandAdvantageNav-img">
                  <img
                    :src="getUrlPrefix(item.images)"
                    style="width: 100%; border-radius: 10px"
                    alt=""
                  />
                </div>
                <div class="title">{{ item.title }}</div>
                <div class="content">
                  {{ item.remark }}
                </div>
              </div>
            </div>
          </div>
          <!-- 自研实力 -->
          <div class="powerNav" ref="powerNav" id="powerNav">
            <div>
              <div
                class="Regular"
                style="color: #000000; font-size: 32px; line-height: 32px"
              >
                自研实力
              </div>
              <div
                style="
                  color: #7d7d7d;
                  font-size: 15px;
                  line-height: 15px;
                  margin-top: 11px;
                "
              >
                ▼
              </div>
            </div>
            <div class="powerNav-content">
              <div
                v-for="(item, index) of selfResearchStrengthList"
                :key="index"
              >
                <div class="Regular" style="color: #719468">
                  <div
                    style="
                      font-size: 90px;
                      line-height: 88px;
                      word-spacing: 0;
                      letter-spacing: 0;
                      height: 90px;
                      display: inline-block;
                      overflow: hidden;
                    "
                    v-if="numShow"
                  >
                    <scrollNumber :num="item.num"></scrollNumber>
                  </div>
                  <div
                    style="
                      font-size: 36px;
                      vertical-align: top;
                      display: inline-block;
                    "
                  >
                    {{ item.unitName }}
                  </div>
                </div>
                <div
                  style="
                    white-space: pre-wrap;
                    text-align: center;
                    margin-top: 42px;
                    font-size: 23px;
                    line-height: 32px;
                    letter-spacing: 5px;
                  "
                >{{ item.remark }}</div>
              </div>
            </div>
          </div>
          <!-- 专利发明 荣誉无数  品牌荣誉 -->
          <div class="CERTIFICATENav" ref="CERTIFICATENav" id="CERTIFICATENav">
            <div>
              <div
                class="Regular"
                style="color: #000000; font-size: 32px; line-height: 32px"
              >
                品牌荣誉
              </div>
              <div
                style="
                  color: #7d7d7d;
                  font-size: 15px;
                  line-height: 15px;
                  margin-top: 11px;
                "
              >
                BRAND HONORS
              </div>
              <div style="margin-top:24px;">
                国家卫健委“十四五”规划全国重点课题研究
              </div>
            </div>
            <div class="CERTIFICATENav-content">
              <div
                v-for="(item, index) of honorsQualificationsList"
                :key="index"
                class="img"
                style="width: 46%; margin-bottom: 40px"
                :style="`transition: all ${(index + 1) * 0.5}s;${
                  CERTIFICATENavShow
                    ? ''
                    : 'transform: translateY(100px);opacity:0'
                }`"
              >
                <div
                  class="Regular enlarge"
                  style="color: #719468; width: 100%"
                >
                  <img
                    :src="getUrlPrefix(item.images)"
                    style="width: 100%"
                    alt=""
                  />
                </div>
                <div
                  class="Regular"
                  style="
                    text-align: center;
                    margin-top: 20px;
                    font-size: 20px;
                    line-height: 26px;
                    color: #434343;
                  "
                >
                  {{ item.name }}
                </div>
              </div>
              <div
                style="width: 100%; margin-top: 42px"
                class="ql-editor"
                v-html="honorsQualifications.configValue"
              ></div>
            </div>
            <div></div>
          </div>
          <!-- 新华社专题报道 -->
          <div class="CERTIFICATENav">
            <div>
              <div
                class="Regular"
                style="color: #000000; font-size: 32px; line-height: 32px"
              >
                新华社专题报道
              </div>
              <!--              <div-->
              <!--                style="-->
              <!--                  color: #7d7d7d;-->
              <!--                  font-size: 18px;-->
              <!--                  line-height: 32px;-->
              <!--                  margin-top: 25px;-->
              <!--                "-->
              <!--              >-->
              <!--                2022年10月，新华社以《以自研为长效驱动力，国产品牌原材料困境》为题，<br />详细报道了御方汇原液原料在化妆品领域的研发、应用与推广。-->
              <!--              </div>-->
            </div>
            <div
              style="padding: 59px 90px 0"
              class="ql-editor"
              v-html="specialReport.configValue"
            ></div>
          </div>
          <!-- 品牌历程 -->
          <div class="historyNav" ref="historyNav" id="historyNav">
            <div>
              <div
                class="Regular"
                style="color: #000000; font-size: 32px; line-height: 32px"
              >
                品牌历程
              </div>
              <div
                style="
                  color: #7d7d7d;
                  font-size: 15px;
                  line-height: 15px;
                  margin-top: 11px;
                "
              >
                HISTORY
              </div>
            </div>
            <div
              style="
                position: relative;
                overflow: hidden;
                padding: 210px 0 20px;
              "
            >
              <div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    padding-left: 100px;
                  "
                  v-for="(item, index) of brandHistoryList"
                  :key="index"
                  :style="
                    (index + 1) % 4 === 1
                      ? 'margin-top: 30px;'
                      : (index + 1) % 4 === 2
                      ? 'margin-top: 35px;'
                      : (index + 1) % 4 === 3
                      ? 'margin-top: 30px;'
                      : 'margin-top: 40px;'
                  "
                >
                  <div
                    class="Regular"
                    style="
                      color: #3e3a39;
                      font-size: 20px;
                      width: 320px;
                      text-align: right;
                    "
                  >
                    {{ item.remark }}
                  </div>
                  <div
                    style="
                      width: 1px;
                      height: 48px;
                      margin: 0 20px;
                      background: #719468;
                    "
                  ></div>
                  <div
                    class="Regular"
                    style="
                      color: #719468;
                      font-size: 54px;
                      line-height: 54px;
                      margin-right: 27px;
                    "
                  >
                    {{ item.name }}
                  </div>
                  <div
                    style="height: 1px; border: 1px solid #719468;background:#719468;"
                    :style="
                      (index + 1) % 4 === 1
                        ? 'width: 40px;'
                        : (index + 1) % 4 === 2
                        ? 'width: 190px;'
                        : (index + 1) % 4 === 3
                        ? 'width: 70px;'
                        : 'width: 170px'
                    "
                  ></div>
                  <div
                    style="
                      width: 7px;
                      height: 7px;
                      background: #719468;
                      border-radius: 50%;
                    "
                  ></div>
                  <div
                    style="width: 80px; z-index: 2"
                    v-if="(index + 1) % 2 === 1"
                  >
                    <img src="@/assets/ye2.png" class="treeShock" alt="" />
                  </div>
                  <div
                    style="width: 80px; z-index: 2"
                    v-if="(index + 1) % 2 === 0"
                  >
                    <img src="@/assets/ye.png" class="treeShock" alt="" />
                  </div>
                </div>
              </div>
              <div
                style="
                  width: 200px;
                  position: absolute;
                  right: 89px;
                  top: 0;
                  z-index: 1;
                "
              >
                <img src="@/assets/tree2.png" style="width: 100%" alt="" />
                <img
                  src="@/assets/tree3.png"
                  style="width: 100%"
                  alt=""
                  v-for="items of treeNum"
                  :key="items"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div style="position: relative; background: #f4f8f3"
      id="brandProfileNavM">
        <div style="position: absolute; left: 0; width: 100%; z-index: 1">
          <img src="@/assets/bg1.png" style="width: 100%" alt="" />
        </div>
        <div style="position: relative; z-index: 2;" class="bottomtoTop" >
          <div style="margin: 0 auto 0; width: 0.7rem; padding: 0.5rem 0 0">
            <img src="@/assets/logo.png" style="width: 100%" alt="" />
          </div>
          <div
            style="
              margin: 0 auto 0;
              padding: 0.2rem 0 0.2rem;
              text-align: center;
              animation-duration:0.2s
            "
             class="bottomtoTop"
          >
            <div
            style="
              margin: 0 auto 0;
              padding: 0.26rem 0 0.2rem;
              text-align: center;
            "
          >
            <div
            style="
              font-size: 0.34rem;
              line-height: 1.4;
              color: #ddd;
              font-weight: 400;
              font-family: 'Proxima-Bold', sans-serif;
              text-transform: uppercase;
            "
          >
            BRADN PROFILE
          </div>
          <div
            style="
              color: #0f3a3c;
              font-weight: 600;
              margin-top: -4px;
            "
            class="fzTitle"
          >
            品牌简介
          </div>
            </div>
          </div>
          <div style="padding: 0 0.2rem 0.25rem;line-height:1.5;animation-duration:0.2s"  class="bottomtoTop" >
            <div style="font-size: 0.16rem; color: #434343">
              御方汇隶属黄家圣幸实业集团旗下品牌，致力于功效性植物复方原液原料的研发、生产、销售以及产品的转化应用。
            </div>
            <div style="font-size: 0.26rem; margin-top: 0.16rem">
              黄家圣幸实业集团简介
            </div>
            <div style="font-size: 0.16rem; margin-top: 0.16rem; color: #434343">
              黄家圣幸实业集团有限公司是一家致力于“尖端中医治疗医养服务”、“功效性植物复方原液原料供应”、“功效性植物复方原液原料产品转化”三大优势产业发展的中医药高新技术企业，以前瞻性的战略思维和极具核心竞争力的功效性植物复方研究，转化能力，打造成集产，学、研、医为一体的圣幸健康产业链和圣幸专属健康产业园。
            </div>
            <div style="width: 100%; margin-top: 0.1rem">
              <img src="@/assets/jieshao1.png" style="width: 100%" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- 品牌文化 -->
      <div
        style="position: relative; background: #f9f9f9;min-height:4rem;"
        ref="brandCultureNavM"
        id="brandCultureNavM"
      >
      <div
          style="
            position: absolute;
            top: 0.5rem;
            left: 0;
            width: 100%;
            z-index: 1;
          "
        >
          <img src="@/assets/bg2.png" style="width: 100%" alt="" />
        </div>
        <div style="position: relative; z-index: 2"  v-if="brandCultureNavShow">
          <div
            style="
              margin: 0 auto 0;
              padding: 0.26rem 0 0.2rem;
              text-align: center;
              animation-duration:0.4s
            "
            class="bottomtoTop"
          >
            <div
            style="
              font-size: 0.34rem;
              line-height: 1.4;
              color: #ddd;
              font-weight: 400;
              font-family: 'Proxima-Bold', sans-serif;
              text-transform: uppercase;
            "
          >
            BRADN CULTURE
          </div>
          <div
            style="
              color: #0f3a3c;
              font-weight: 600;
              margin-top: -4px;
            "
            class="fzTitle"
          >
            品牌文化
          </div>
          </div>
          <div
            style="display: flex; justify-content: center"
            ref="brandAdvantageNav"
          >
            <div
              v-for="(item, index) of brandCultureList"
              :key="index"
              class="bottomtoTop"
              style="
                width: 0.64rem;
                position: relative;
                margin: 0.26rem 0.25rem 0.3rem;
                padding: 0.11rem 0;
                display: flex;
              "
              :style="`animation-duration:${0.4+(index*0.2)}s`"
            >
              <img
                src="@/assets/mobile/bg3.png"
                style="
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                "
                alt=""
              />
              <!-- <div class="wrap_left_top"></div>
                <div class="wrap_right_top"></div>
                <div class="wrap_left_bottom"></div>
                <div class="wrap_right_bottom"></div> -->
              <div
                style="
                  margin: 0 auto;
                  width: 0.2rem;
                  color: #535353;
                  text-align: center;
                "
              >
                <div class="bold" style="color: #0f3a3c;
              font-weight: 600;font-size: 0.16rem">
                  {{ item.title }}
                </div>
                <div
                  style="
                    width: 1px;
                    height: 0.2rem;
                    background: #535353;
                    margin: 0.05rem auto 0;
                  "
                ></div>
                <div style="font-size: 0.12rem; color: #535353">
                  {{ item.remark }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 品牌优势 -->
      <div style="background: #f4f8f3;min-height:3rem;" id="brandAdvantageNavM">
        <div
          style="
            margin: 0 auto 0;
            padding: 0.26rem 0 0.2rem;
            text-align: center;
            animation-duration:0.3s
          "
          v-if="brandAdvantageNavShow"
          class="bottomtoTop"
        >
          <div
            style="
              font-size: 0.34rem;
              line-height: 1.4;
              color: #ddd;
              font-weight: 400;
              font-family: 'Proxima-Bold', sans-serif;
              text-transform: uppercase;
            "
          >
            BRADN ADVANTAGE
          </div>
          <div
            style="
              color: #0f3a3c;
              font-weight: 600;
              margin-top: -4px;
            "
            class="fzTitle"
          >
            品牌优势
          </div>
        </div>
        <div
          style="
            z-index: 100;
            position: relative;
            display: flex;
            padding: 0.21rem;
          "
          v-if="brandAdvantageNavShow"
        >
          <div
            v-for="(item, index) in brandAdvantagesList"
            :key="index"
            class="bottomtoTop"
            :style="`flex:1;animation-duration:${0.4+(index*0.2)}s;${index !== 2 ? `margin-right:0.16rem;` : ''}`"
          >
            <div class="img">
              <img
                :src="getUrlPrefix(item.images)"
                style="width: 100%"
                alt=""
              />
            </div>
            <div
              style="
                font-size: 0.12rem;
                margin-top: 0.1rem;
                text-align: center;
                color: #000;
              "
            >
              {{ item.title }}
            </div>
            <div
              style="
                font-size: 0.11rem;
                text-align: left;
                margin-top: 0.02rem;
                color: #535353;
              "
              class="content"
            >
              {{ item.remark }}
            </div>
          </div>
        </div>
        <div
          style="
            margin: 0 auto 0;
            padding: 0.33rem 0 0.1rem;
            text-align: center;
          "
        >
           <div
            style="
              color: #0f3a3c;
              font-weight: 600;
              margin-top: -4px;
            "
            class="fzTitle"
          >
            自研实力
          </div>
          
          <div style="font-size: 0.1rem; color: #7d7d7d">▼</div>
        </div>
      </div>
      <!-- 自研实力 -->
      <div style="display: flex; flex-wrap: wrap; padding-bottom: 0.2rem"
      id="powerNavM">
        <div
          v-for="(item, index) of selfResearchStrengthList"
          :key="index"
          style="width: 50%; text-align: center; margin-top: 0.32rem"
        >
          <diV style="color: #719468">
            <div
              style="
                font-size: 0.35rem;
                word-spacing: 0;
                letter-spacing: 0;
                display: inline-block;
                overflow: hidden;
              "
            >
              {{ item.num }}
            </div>
            <div
              style="
                font-size: 0.14rem;
                vertical-align: top;
                display: inline-block;
              "
            >
              {{ item.unitName }}
            </div>
          </diV>
          <div
            style="
              white-space: pre-wrap;
              text-align: center;
              margin-top: 0.05rem;
              font-size: 0.16rem;
            "
          >{{ item.remark }}</div>
        </div>
      </div>
      <div style="background: #f9f9f9; padding-bottom: 0.2rem" id="CERTIFICATENavM">
        <div
          style="
            margin: 0 auto 0;
            padding: 0.26rem 0 0.2rem;
            text-align: center;
          "
        >
          <div
            style="
              font-size: 0.34rem;
              line-height: 1.4;
              color: #ddd;
              font-weight: 400;
              font-family: 'Proxima-Bold', sans-serif;
              text-transform: uppercase;
            "
          >
            BRAND HONORS
          </div>
          <div
            style="
              color: #0f3a3c;
              font-weight: 600;
              margin-top: -4px;
            "
            class="fzTitle"
          >
            品牌荣誉
          </div>
          <div style="margin-top:24px;font-size:0.18rem;">
                国家卫健委“十四五”规划全国重点课题研究
              </div>
        </div>
        <div
          style="display: flex; justify-content: space-around; flex-wrap: wrap"
        >
          <div
            v-for="(item, index) of honorsQualificationsList"
            :key="index"
            style="width: 46%; margin-bottom: 0.05rem"
          >
            <div class="Regular" style="color: #719468; width: 100%">
              <img
                :src="getUrlPrefix(item.images)"
                style="width: 100%"
                alt=""
              />
            </div>
            <div
              class="Regular"
              style="
                text-align: center;
                margin-top: 0.1rem;
                font-size: 0.14rem;
                color: #434343;
              "
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div
          style="width: 100%; margin-top: 42px"
          class="ql-editor"
          v-html="honorsQualifications.configValue"
        ></div>
      </div>
      <!-- 新华社专题报道 -->
      <div>
        <div>
          <div
            style="
              color: #0f3a3c;
              font-weight: 600;
              margin-top:0.2rem;
              text-align: center;
            "
            class="fzTitle"
          >
            新华社专题报道
          </div>
        </div>
        <div
          style="padding: 0.2rem; font-size: 0.16rem"
          class="ql-editor editor"
          v-html="specialReport.configValue"
        ></div>
      </div>
      <div style="background: #f9f9f9; padding-bottom: 0.2rem" id="historyNavM">
        <div
          style="
            margin: 0 auto 0;
            padding: 0.26rem 0 0.2rem;
            text-align: center;
          "
        >
          <div
            style="
              font-size: 0.34rem;
              line-height: 1.4;
              color: #ddd;
              font-weight: 400;
              font-family: 'Proxima-Bold', sans-serif;
              text-transform: uppercase;
            "
          >
            HISTORY
          </div>
          <div
            style="
              color: #0f3a3c;
              font-weight: 600;
              margin-top: -4px;
            "
            class="fzTitle"
          >
            品牌历程
          </div>
        </div>
        <!-- <div style="display:flex;align-items:center;padding:0.7rem 0 1rem;overflow:scroll;" >
          <div v-for="(item,index) of brandHistoryList">
            <div style="display:flex;align-items:center;position:relative;">
              <div style="width:0.92rem;height:0.01rem;background:#719468;"></div>
              <div style="width:0.05rem;height:0.05rem;background:#719468;border-radius:0.5rem;margin:0 0.01rem;"></div>
              <div style="position:absolute;right:-0.2rem;" :style="index%2 === 0?`top:-0.5rem;`:`top:0.3rem;`">
                {{ item.name }}
              </div>
              <div style="position:absolute;right:-0.6rem;font-size:0.1rem;width:1.2rem;" :style="index%2 === 0?`top:0.3rem;`:`top:-0.5rem;`">
                {{ item.remark }}
              </div>
            </div>
          </div>
          <div style="display:flex;align-items:center;position:relative;">
          <div style="width:0.92rem;height:0.01rem;background:#719468;"></div>
          </div>
        </div> -->
        <div class="floor_flow6 display1">
        <div
          class="component_body swiper-container"
          style="position: relative; padding: 0"
        >
          <div
            class="center_line"
            style="
              background: #719468;
              position: absolute;
              top: 50%;
              left: 0;
              width: 100%;
              height: 1px;
            "
          ></div>
          <ul
            class="flow6 swiper-wrapper"
            style="
              padding-left: 0px;
              padding-right: 0px;
              height: 2.5rem;
            "
          >
            <template v-for="(item, index) of brandHistoryList">
              <li
                class="n1 m0 swiper-slide animate__animated animate__fadeInLeft"
                style="animation-delay: 0s; opacity: 1"
                v-if="index % 2 === 1"
                :key="index"
              >
                <div
                  class="SubTitle"
                  style="color: #719468; font-weight: bold; font-style: normal"
                >
                  {{ item.name }}
                </div>
                <div class="point_back">
                  <div class="point_big"></div>
                  <div class="point_small"></div>
                </div>
                <div
                  class="Description"
                  style="
                    color: #444444;
                    font-weight: normal;
                    font-style: normal;
                  "
                >
                  {{ item.remark }}
                </div>
              </li>
              <li
                class="n2 m1 swiper-slide animate__animated animate__fadeInLeft"
                yd-animation="animate__animated animate__fadeInLeft"
                style="animation-delay: 0.1s; opacity: 1"
                v-if="index % 2 === 0"
                :key="index"
              >
                <div class="Description">{{ item.remark }}</div>
                <div class="point_back">
                  <div class="point_big"></div>
                  <div class="point_small"></div>
                </div>
                <div class="SubTitle"
                  style="color: #719468; font-weight: bold; font-style: normal;" >{{ item.name }}</div>
              </li>
            </template>
          </ul>
        </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->

    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import $ from 'jquery'
import headerNav from '@/components/headerNav/index'
import bannerNav from '@/components/banner/index'
import footerNav from '@/components/footerNav/index'
import scrollNumber from '@/components/scrollNumber/scroll-number'
import { getAboutUsListByType } from '@/api/aboutUs'
import { getConfByKey } from '@/api/common'
export default {
  name: 'aboutUs',
  components: { headerNav, footerNav, bannerNav, scrollNumber },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: [],
      }, //轮播图
      show: false,
      mobile: false,
      navIndex: 1,
      brandProfileNavShow: false,
      CERTIFICATENavShow: false,
      brandCultureNavShow:false,
      brandAdvantageNavShow:false,
      top: 100,
      numShow: false,
      brandCultureList: [], //品牌文化数据集合
      brandAdvantagesList: [], //品牌优势数据集合
      honorsQualificationsList: [], //科研成果数据集合
      honorsQualifications: {}, //科研成果参数对象
      brandHistoryList: [], //品牌历程数据集合
      selfResearchStrengthList: [], //自研实力数据集合
      specialReport: {}, //专题报告对象
      treeNum: 0, //树干的数量
    }
  },
  mounted() {
    this.mobile = this.isMobile()
    this.brandProfileNavShow = true
    if(this.mobile === false){
      window.addEventListener('scroll', this.getScroll)
    }
    this.getAboutUsData()
    if(this.isMobile() === true){
      window.addEventListener('scroll', this.getScroll1)
      this.postMessage(
          '御方汇植物化妆品原料【官网】',
          '关于我们',
          window.location.href,
          this.getUrlPrefix(this.getBaseInfo().logo)
        );
    }
  },
  methods: {
    getScroll() {
      var mainNav = document.getElementById('mainNav').offsetTop
      var aboutUsIndex = document.getElementById('aboutUsIndex').scrollHeight
      var brandProfileNav = document.getElementById('brandProfileNav').offsetTop
      var brandCultureNav = document.getElementById('brandCultureNav').offsetTop
      var brandAdvantageNav =
        document.getElementById('brandAdvantageNav').offsetTop
      var CERTIFICATENav = document.getElementById('CERTIFICATENav').offsetTop
      var powerNav = document.getElementById('powerNav').scrollHeight
      var historyNav = document.getElementById('historyNav').offsetTop
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.mobile === false) {
        this.show = aboutUsIndex + 200 < scrollTop
        if (scrollTop === 0) {
          this.navIndex = 1
          this.CERTIFICATENavShow = false
          this.numShow = false
        }
        if (mainNav + historyNav - 150 < scrollTop) {
          this.navIndex = 5
          this.top = 324
        } else if (mainNav + CERTIFICATENav - 150 < scrollTop) {
          this.navIndex = 4
          this.top = 267
          this.CERTIFICATENavShow = true
        } else if (mainNav + brandAdvantageNav - 150 < scrollTop) {
          this.navIndex = 3
          this.top = 210
          if (mainNav + powerNav + 1500 < scrollTop) {
            this.numShow = true
          }
        } else if (mainNav + brandCultureNav - 150 < scrollTop) {
          this.navIndex = 2
          this.top = 153
        } else if (mainNav + brandProfileNav - 150 < scrollTop) {
          this.navIndex = 1
          this.top = 96
        }
      }
    },
    getScroll1() {
      var brandCultureNav = document.getElementById('brandCultureNavM').offsetTop
      var brandAdvantageNav = document.getElementById('brandAdvantageNavM').offsetTop
      var powerNav = document.getElementById('powerNavM').offsetTop
      var CERTIFICATENav = document.getElementById('CERTIFICATENavM').offsetTop
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // console.log(document.documentElement.clientHeight)
      // console.log(a)
      var height = scrollTop+document.documentElement.clientHeight
      if (brandCultureNav < height-200 ) {
        this.brandCultureNavShow = true
      }
      if(brandAdvantageNav<height-200){
        this.brandAdvantageNavShow = true
      }
      // var news = document.getElementById('newsM').offsetTop
      // var huoban = document.getElementById('huobanM').offsetTop
      console.log(brandCultureNav,brandAdvantageNav,height)
    },
    goNav(name) {
      // console.log($(`#${name}`))
      // $(`#${name}`).animate({ scrollTop: 0 }, 1000);
      // this.$refs[name].scrollIntoView({
      //   behavior: "smooth",
      //   block: "end",
      // });
      var top = 500
      if(this.isMobile() === true){
        name = name+"M"
        top = 0
      }
      
      var a = document.getElementById(name).offsetTop
      $('body,html').animate({ scrollTop: a + top }, 200)
    },
    setBanner(url,mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      }
    },
    getAboutUsData() {
      //1.品牌文化 2.品牌优势 3.科研成果 4.品牌历程 5.自研实力
      getAboutUsListByType({ type: 1 }).then((response) => {
        this.brandCultureList = response.data
      })
      getAboutUsListByType({ type: 2 }).then((response) => {
        this.brandAdvantagesList = response.data
      })
      getAboutUsListByType({ type: 3 }).then((response) => {
        this.honorsQualificationsList = response.data
      })
      getAboutUsListByType({ type: 4 }).then((response) => {
        this.brandHistoryList = response.data
        if (this.brandHistoryList.length > 8) {
          this.treeNum = Math.ceil((this.brandHistoryList.length - 8) / 4)
        }
      })
      getAboutUsListByType({ type: 5 }).then((response) => {
        // response.data.forEach(item => {
        //   item.remark = item.remark.replace(" ","<br>")
        //   console.log(item.remark)
        // });
        this.selfResearchStrengthList = response.data
      })
      //查询品牌荣誉参数维护
      getConfByKey({ key: 'sys.aboutUs.honorsQualifications' }).then(
        (response) => {
          this.honorsQualifications = response.data
        }
      )
      //查询专题报告
      getConfByKey({ key: 'sys.aboutUs.specialReport' }).then((response) => {
        this.specialReport = response.data
        if (window.location.hash !== '') {
          var name = window.location.hash.replace('#', '')
          this.$nextTick(() => {
            this.goNav(name)
          })
        }
      })
    },
    touchStart: function (ev) {
      ev = ev || event
      ev.preventDefault()
      //      console.log(ev.targetTouches);
      //      console.log(ev.changedTouches);
      if (ev.touches.length == 1) {
        //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
        var startX = ev.touches[0].clientX // 记录开始位置
        console.log(startX)
      }
    },
    touchMove: function (ev) {
      console.log(ev)
    },
    touchEnd: function (ev) {
      console.log(ev)
    },
    getUrl(val){
      var name = val.replace('#', '')
      this.$nextTick(() => {
        this.goNav(name)
      })
    }
  },
  
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
}
</script>

<style lang="scss">
.aboutNav {
  .maxWidth {
    width: 1229px;
    margin: 0 auto;
  }
  .mainIndex {
    width: 217px;
  }
  .mainContent {
    flex: 1;
  }
  .mainNav {
    position: relative;
    margin-top: 80px;
    display: flex;
  }
  .brandProfileNav {
    position: relative;
  }
  .mainIndex {
    text-align: right;
    padding-right: 55px;
    ul {
      padding: 8px 55px 8px 0;
      border-right: 1px solid #000;
    }
    .title {
      color: #1b1b1b;
      font-size: 27px;
      line-height: 27px;
      margin-bottom: 32px;
    }
    .index {
      color: #707070;
      font-size: 18px;
      line-height: 27px;
      margin-bottom: 30px;
    }
    .index:last-child {
      margin-bottom: 0;
    }
  }
  .brandCultureNav {
    position: relative;
    padding: 40px 0;
    margin: 60px auto 0;
    background: #f9f9f9;
    text-align: center;
    .brandCultureNav-content {
      display: flex;
      justify-content: center;

      .wrap {
        width: 108px;
        position: relative;
        margin: 86px 73px 0;
        padding: 30px 0;
        display: flex;
      }
    }
  }

  .brandAdvantageNav {
    position: relative;
    padding: 40px 0;
    margin: 0 auto;
    text-align: center;
    background: #f4f8f3;
    .brandAdvantageNav-content {
      display: flex;
      justify-content: center;
      margin-top: 79px;
      > div {
        margin-right: 40px;
      }
      > div:last-child {
        margin-right: 0;
      }
      .title {
        color: #000000;
        font-size: 23px;
        line-height: 23px;
        text-align: center;
        margin: 22px 0 18px;
      }
      .content {
        color: #535353;
        font-size: 16px;
        line-height: 27px;
        text-align: justify;
      }
    }
  }
  .powerNav {
    position: relative;
    padding: 40px 0;
    margin: 0 auto;
    text-align: center;
    background: #f4f8f3;
    .powerNav-content {
      display: flex;
      justify-content: center;
      background: #fdfffc;
      padding: 41px 0;
      margin: 79px 20px 0;
      zoom: 0.9;
      > div {
        margin-right: 40px;
      }
      > div:last-child {
        margin-right: 0;
      }
      .title {
        color: #000000;
        font-size: 23px;
        line-height: 23px;
        text-align: center;
        margin: 22px 0 18px;
      }
      .content {
        color: #535353;
        font-size: 18px;
        line-height: 27px;
        text-align: center;
      }
    }
  }
  .CERTIFICATENav {
    position: relative;
    padding: 40px 0;
    margin: 0 auto;
    text-align: center;
    background: #f9f9f9;
    .CERTIFICATENav-content {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0px 90px;
      margin: 30px 20px 0;
      zoom: 0.9;
      .img {
        margin-right: 4%;
      }
      .img:nth-child(2n) {
        margin-right: 0;
      }
      .title {
        color: #000000;
        font-size: 23px;
        line-height: 23px;
        text-align: center;
        margin: 22px 0 18px;
      }
    }
  }
  .historyNav {
    position: relative;
    padding: 40px 0;
    margin: 0 auto;
    text-align: center;
    background: #f4f8f3;
  }
  .clickBtn2 {
    cursor: pointer;
  }
  .selectBtn {
    color: #3f6b33;
    cursor: pointer;
    position: relative;
  }
  .selectBtn1::after {
    content: '';
    width: 100%;
    height: 2px;
    background: #3f6b33;
    position: absolute;
    bottom: -10px;
    left: 0;
    transition: all 0.5s ease 0s;
  }
  .brandAdvantageNav-img {
    transition: all 0.5s;
  }
  .brandAdvantageNav-img:hover {
    transform: translateY(-10px);
  }

  .swiper-wrapper {
    position: relative;
    width: 100%;
    -webkit-transition-property: -webkit-transform, left, top;
    -webkit-transition-duration: 0s;
    -webkit-transform: translate3d(0px, 0, 0);
    -webkit-transition-timing-function: ease;
    -moz-transition-property: -moz-transform, left, top;
    -moz-transition-duration: 0s;
    -moz-transform: translate3d(0px, 0, 0);
    -moz-transition-timing-function: ease;
    -o-transition-property: -o-transform, left, top;
    -o-transition-duration: 0s;
    -o-transform: translate3d(0px, 0, 0);
    -o-transition-timing-function: ease;
    -o-transform: translate(0px, 0px);
    -ms-transition-property: -ms-transform, left, top;
    -ms-transition-duration: 0s;
    -ms-transform: translate3d(0px, 0, 0);
    -ms-transition-timing-function: ease;
    transition-property: transform, left, top;
    transition-duration: 0s;
    transform: translate3d(0px, 0, 0);
    transition-timing-function: ease;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }
  .swiper-container {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    direction: ltr;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    -o-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1;
  }

  /*发展历程组件6*/
  .floor_flow6 {
    max-width: 14.4rem;
    margin: 0 auto;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .floor_flow6 .component_body {
    position: relative;
    padding: 0;
  }
  .floor_flow6 .center_line {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background: #aaa;
  }
  .floor_flow6 ul {
    overflow: hidden;
    text-align: center;
    min-width: 100%;
  }
  .floor_flow6 li {
    position: relative;
    float: none;
    display: inline-block;
    width: 2rem;
    margin: 0;
    vertical-align: middle;
  }
  .floor_flow6 li .point_back {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    margin-left: -0.25rem;
    margin-top: -0.25rem;
    background: #f9f9f9;
  }
  .floor_flow6 li .point_big {
    position: absolute;
    top: 0.15rem;
    left: 0.15rem;
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    background: #719468;
    opacity: 0.3;
  }
  .floor_flow6 li .point_small {
    position: absolute;
    top: 0.18rem;
    left: 0.18rem;
    width: 0.14rem;
    height: 0.14rem;
    border-radius: 50%;
    background: #719468;
  }
  .floor_flow6 li .SubTitle {
    font-size: 0.26rem;
    font-weight: bold;
    height: 1rem;
    line-height: 1rem;
    margin: 0;
    text-align: center;
  }
  .floor_flow6 li .Description {
    position: relative;
    width: 90%;
    height: 0.6rem;
    font-size: 0.13rem;
    line-height: 1.5;
    text-align: left;
    margin: 0 auto;
    overflow: hidden;
  }
  .floor_flow6 li.m0 .Description {
    padding-top: 0.9rem;
  }
  .floor_flow6 li.m1 .Description {
    padding-bottom: 0.9rem;
  }
  .floor_flow6 li .Description:before {
    content: '';
    position: absolute;
    width: 0.01rem;
    height: 0.8rem;
    left: 50%;
    top: 0;
    background: #719468;
    z-index: -1;
    opacity: 0.6;
  }
  .floor_flow6 li.m1 .Description:before {
    top: auto;
    bottom: 0;
  }
  .floor_flow6 ul {overflow:scroll;white-space:nowrap;}
	.floor_flow6 ul li { white-space:normal; }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/index.vue